import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';

@Component({
  selector: 'app-modal-assign-audit',
  templateUrl: './modal-assign-audit.component.html',
  styles: []
})
export class ModalAssignAuditComponent extends ExcTranslation  implements OnInit {
  auditor;
  auditors: [];

  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef, private excSec: ExcSigninService) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    _self.auditors = _self.overlayConfig.data.auditors;
    _self.auditor = _self.overlayConfig.data.data.AuditorID ?  '' + _self.overlayConfig.data.data.AuditorID : '' ;
  }

  dispose() {
    const _self = this;
    _self.overlayRef.close({proceed: true, auditor: _self.auditor});
  }
}
